module.exports = __webpack_public_path__ + "static/img/hb_8-min.b1d5899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_8-min.png
// module id = Vdz8
// module chunks = 1